export const BLOG_RCE_STATICS = 'static.parastorage.com/unpkg/@wix/communities-blog-rce@1.0.613/dist/statics';
export const BLOG_RCE_NEXT_STATICS = 'static.parastorage.com/unpkg/@wix/communities-blog-rce-next@1.0.208/dist/statics';
